import { getSearchPath } from "src/consts/urlPaths";

export const GRADE_COMPRESSION_TEAM_PARAM = "gradeCompressionTeam";
export const GRADE_COMPRESSION_PIT_PARAM = "gradeCompressionPit";

/** People page for the team, showing the same people the card counts. */
export const gradeCompressionPeoplePath = (
  teamId: string,
  pit?: string
): string => {
  const path = getSearchPath("people", null, false);
  const params = new URLSearchParams();
  params.set(GRADE_COMPRESSION_TEAM_PARAM, teamId);
  if (pit) {
    params.set(GRADE_COMPRESSION_PIT_PARAM, pit);
  }
  return `${path}?${params.toString()}`;
};

export const parseGradeCompressionPeopleSearch = (
  search: string
): { teamId: string; pit?: string } | null => {
  const params = new URLSearchParams(search);
  const teamId = params.get(GRADE_COMPRESSION_TEAM_PARAM)?.trim() ?? "";
  if (!teamId) {
    return null;
  }
  const pit = params.get(GRADE_COMPRESSION_PIT_PARAM)?.trim() || undefined;
  return pit ? { teamId, pit } : { teamId };
};

/** Query string to keep when other search filters are stripped. */
export const gradeCompressionPeopleSearch = (search: string): string => {
  const parsed = parseGradeCompressionPeopleSearch(search);
  if (!parsed) {
    return "";
  }
  const params = new URLSearchParams();
  params.set(GRADE_COMPRESSION_TEAM_PARAM, parsed.teamId);
  if (parsed.pit) {
    params.set(GRADE_COMPRESSION_PIT_PARAM, parsed.pit);
  }
  return `?${params.toString()}`;
};
